import React from 'react';
import { Route, Switch } from 'react-router-dom';
import './assets/scss/index.scss';
import { MasterRouter } from 'features/master';
import HomePage from 'features/home';
import MenuPage from 'features/menu';

import SocketComponent from 'components/SocketComponent';

function App() {
  return (
    <>
      <Switch>
        {/* Change route from show bill first to show menu first */}
        <MasterRouter exact path="/bills-table-detail" component={() => <MenuPage />} />
        <MasterRouter exact path="/show-bill" component={() => <HomePage />} />
        {/* <Route path="/" element={<HomePage />} /> */}
      </Switch>
      <SocketComponent />
    </>
  );
}

export default App;
